<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { interactionMixin } from "src/modules/interactions_module.js";
import { sendFandomAnalyticsEvent } from "src/modules/fandom_analytics_module.js"
import shave from "shave";

export default {
  props: {
    index: Number,
    lazyloadBg: {
      type: Boolean,
      default: false
    }
  },
  mixins: [fandomBasicMixin, interactionMixin],
  updated() {
    this.shaveHeight();
  },
  mounted() {
    $(window).on("debouncedResize", this.shaveHeight);
  },
  methods: {
    getContentResponsiveImage: Fandom.getContentResponsiveImage,
    getBackgroundUrl: Fandom.getBackgroundUrl,
    shaveHeight() {
      Vue.nextTick(() => {
        shave(".dotdotdot", this.getTileHeight());
      });
    },
    getTileHeight() {
      return Math.round($(".tile-story__text-content").height());
    },
    openStory() {
      if(this.content.chapters.length > 0) {
        this.$emit("tile-story-opened", this.content);
        sendFandomAnalyticsEvent("Interaction", "Stories Click", this.content.title);
      }
    },
  },
  computed: {
    thumbStyle() {
      const alreadyLoaded = Fandom.exists(this.$refs["thumbnail"]) ? !this.$refs["thumbnail"].classList.contains("flickity-bg-lazyloaded") : false;
      return {
        "background-image": (this.lazyloadBg && alreadyLoaded) ? null : this.getContentResponsiveImageURL("thumbnail")
      };
    },
    lazyThumb() {
      return this.lazyloadBg ? this.getContentResponsiveImage("thumbnail") : null;
    }
  }
};
</script> 

<template>
  <div v-easyadmin="easyadminId" :id="`ref-${easyadminId}`" :class="contentType" class="w-100" tile-story>
    <a class="tile-story__link" href="javascript:void(0)" @click="openStory()"></a>
    <div class="tile-story__content d-flex flex-column">
      <div class="tile-story__thumbnail bg-transition w-100" ref="thumbnail" :style="thumbStyle" :data-flickity-bg-lazyload="lazyThumb"></div>
      <div class="tile-story__title-wrapper w-100">
        <div class="tile-story__title-content w-100">
          <p class="tile-story__title text-orange">{{content.title}}</p>
        </div>
      </div>
      <div class="tile-story__text-wrapper w-100">
        <div class="tile-story__text-content w-100">
          <p class="p-0 pb-3 pb-sm-0 m-0 dotdotdot font-sm" v-html="content.description"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[tile-story] {
  padding-bottom: 180%;
  position: relative;
  
  .tile-story__link {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
  }
  
  .tile-story__thumbnail {
    background-size: cover;
    background-position: center center;
    padding-bottom: 140%;
  }

  .tile-story__text-wrapper {
    padding-bottom: 28%;
    position: relative;
    overflow: hidden;
  }
  
  .tile-story__title-wrapper {
    padding-bottom: 12%;
    position: relative;
    overflow: hidden;
  }
  
  @include media-breakpoint-down(xs) {
    .tile-story__thumbnail {
      padding-bottom: 142%;
    }

    .tile-story__text-wrapper {
      padding-bottom: 34%;
    }
    
    .tile-story__title-wrapper {
      padding-bottom: 24%;
    }
  }

  .tile-story__text-content, .tile-story__title-content,
  .tile-story__content {
    position: absolute;
    overflow: hidden;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  
  .tile-story__content {
    left: 8px;
    right: 8px;
  }
  
  .tile-story__text-content {
    p {
      margin: 0;
    }
  }
  
  .tile-story__title {
    margin-top: .8rem;
    margin-bottom: 0;
    text-transform: uppercase;
  }
  
}
</style>
